import { VisibleColumnSpec, WeightReportLineDetails } from "@/types";

export const DEFAULT_WEIGHT_REPORTS_COLUMN: VisibleColumnSpec<WeightReportLineDetails, "actions">[] = [
  // "projectName",
  "customerName",
  "article",
  "netWeight",
  { id: "weightDate", breakpoint: "mantine-visible-from-lg" },
  { id: "weightTime", breakpoint: "mantine-visible-from-xl" },
  { id: "truckNumber", breakpoint: "mantine-visible-from-md" },
  { id: "matchedOrderId", breakpoint: "mantine-visible-from-md" },
  { id: "matchStatus", breakpoint: "mantine-visible-from-sm" },
  "actions",
  // "unit",
  // "documentRef",
  // "rawParsedData",
  //"idNr",
  //"customerNumber",
  //"id",
  //"senderCompanyId",
];
